import { Fragment } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Skeleton,
} from "@mui/material";

function MenuSkeleton() {
  return (
    <div className="h-screen">
      <List>
        {Array(4)
          .fill(null)
          .map((_, i0) => (
            <Fragment key={`outsidemenu${i0}`}>
              <ListItem sx={{ paddingX: 1, paddingY: 0 }}>
                <Skeleton width={"100%"} height={35} />
              </ListItem>
              {Array(5)
                .fill(null)
                .map((_, i1) => (
                  <ListItem
                    key={`insideLabel${i1}`}
                    sx={{ paddingX: 2, paddingY: 0 }}
                  >
                    <ListItemIcon>
                      <Skeleton width={"60%"} height={30} />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Skeleton width={"100%"} height={10} />}
                    />
                  </ListItem>
                ))}
            </Fragment>
          ))}
      </List>
    </div>
  );
}

export default MenuSkeleton;
